"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMouseEvent = void 0;
var tslib_1 = require("tslib");
var react_1 = require("react");
var utils_1 = require("../../utils");
var useMouseEvent = function () {
    var _a = tslib_1.__read((0, utils_1.useStateAsStream)(undefined), 2), 
    // dummy comment to control prettier
    _mouseEvent$ = _a[0], setMouseEvent = _a[1];
    var mouseEvent$ = (0, utils_1.useStream)(_mouseEvent$.pipe((0, utils_1.filterNotUndefined)()));
    var onMouseLeftDown = (0, react_1.useCallback)(function () {
        setMouseEvent('left-down');
    }, [setMouseEvent]);
    var onMouseLeftUp = (0, react_1.useCallback)(function () {
        setMouseEvent('left-up');
    }, [setMouseEvent]);
    var onMouseRightDown = (0, react_1.useCallback)(function () {
        setMouseEvent('right-down');
    }, [setMouseEvent]);
    var onMouseRightUp = (0, react_1.useCallback)(function () {
        setMouseEvent('right-up');
    }, [setMouseEvent]);
    var onMouseLeave = (0, react_1.useCallback)(function () {
        setMouseEvent('leave');
    }, [setMouseEvent]);
    var onMouseEnter = (0, react_1.useCallback)(function () {
        setMouseEvent('enter');
    }, [setMouseEvent]);
    return {
        mouseEvent$: mouseEvent$,
        onMouseLeftDown: onMouseLeftDown,
        onMouseLeftUp: onMouseLeftUp,
        onMouseRightDown: onMouseRightDown,
        onMouseRightUp: onMouseRightUp,
        onMouseLeave: onMouseLeave,
        onMouseEnter: onMouseEnter
    };
};
exports.useMouseEvent = useMouseEvent;
